import { render, staticRenderFns } from "./chateau-fleur-cardinale.vue?vue&type=template&id=4705f851&scoped=true"
import script from "./chateau-fleur-cardinale.vue?vue&type=script&lang=js"
export * from "./chateau-fleur-cardinale.vue?vue&type=script&lang=js"
import style0 from "./chateau-fleur-cardinale.vue?vue&type=style&index=0&id=4705f851&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4705f851",
  null
  
)

export default component.exports